<template>
  <v-icon :size="size" :color="color">{{ icon }}</v-icon>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      required: false
    },
    color: {
      type: String,
      required: false
    }
  }
};
</script>
